import cjsModule from '../index.js';
export var configure = cjsModule.configure;
export var stringify = cjsModule;
export default cjsModule;